import { css, cx, useTheme } from '@fable/theme'
import { FlexBox, Text } from '@fable/components'
import { useShareOptions } from '@fable/hooks'
import { Book, ShareOption } from '@fable/types'
import { useLocation } from 'react-router-dom'
import { useActions } from 'hooks'
import { GIFTS_ENABLED } from 'app/store/constants'
import { routes as socialRoutes } from 'app/social/routes'
import { isUrlMatched } from 'utils'

export const BookDetailReviewShareOptions = ({
  url,
  book,
}: {
  url: string
  book: Book
}) => {
  const { closeModal } = useActions()
  const location = useLocation()
  const { colors, nativeOverrides } = useTheme()
  const { copyTextToClipboard } = useActions()

  const showGiftBookButton =
    GIFTS_ENABLED &&
    !!book?.can_purchase &&
    !book.is_free &&
    !isUrlMatched(`${socialRoutes.bookList}/:id`, location.pathname, true)

  const options = useShareOptions({
    category: 'review',
    url,
    showGiftBookButton,
    onCopyToClipboard: copyTextToClipboard,
  })

  const handleClickShare = (option: ShareOption) => {
    if (option.isExternal) {
      window.open(option.action() as string, '_blank')
    } else {
      option.action()
    }
  }

  return (
    <div
      className={css`
        width: 100%;
        min-width: 336px;
        padding-bottom: 15px;
      `}
      onClick={closeModal}
    >
      <ul>
        {options.map((option, i) => (
          <li key={i}>
            <button
              className={cx(
                nativeOverrides.buttonClear,
                css`
                  padding: 16px 30px;
                  width: 100%;
                  &:hover {
                    background: ${colors.almostWhite};
                  }
                `
              )}
              onClick={() => handleClickShare(option)}
            >
              <FlexBox alignItems="center">
                <img
                  className={css`
                    width: 24px;
                    margin-right: 10px;
                  `}
                  src={option.icon}
                  alt={option.title}
                />
                <Text
                  className={css`
                    white-space: nowrap;
                  `}
                  type="body"
                  sizing="L"
                >
                  {option.title}
                </Text>
              </FlexBox>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
